/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { OrgAdminEnrollUserCourseOptions, OrgAdminEnrollUserCourseStatus200, OrgAdminEnrollUserCourseStatus422 } from '../models/OrgAdminEnrollUserCourse'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { orgAdminEnrollUserCourse } from '../clients/axios/orgAdminEnrollUserCourse'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const orgAdminEnrollUserCourseMutationKey = () => [{ url: '/course/enroll-user' }] as const

export function orgAdminEnrollUserCourseMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = orgAdminEnrollUserCourseMutationKey()
  return mutationOptions<OrgAdminEnrollUserCourseStatus200, ResponseErrorConfig<OrgAdminEnrollUserCourseStatus422>, OrgAdminEnrollUserCourseOptions, TContext>({
    mutationKey,
    mutationFn: async({ body }) => {
      return await orgAdminEnrollUserCourse({ ...config, body, throwOnError: true })
    },
  })
}

/**
 * @summary Enroll User Course
 * {@link /course/enroll-user}
 */
export function useOrgAdminEnrollUserCourse<TContext>(options: {
  mutation?: UseMutationOptions<OrgAdminEnrollUserCourseStatus200, ResponseErrorConfig<OrgAdminEnrollUserCourseStatus422>, OrgAdminEnrollUserCourseOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? orgAdminEnrollUserCourseMutationKey()

  const baseOptions = orgAdminEnrollUserCourseMutationOptions(config) as UseMutationOptions<OrgAdminEnrollUserCourseStatus200, ResponseErrorConfig<OrgAdminEnrollUserCourseStatus422>, OrgAdminEnrollUserCourseOptions, TContext>

  return useMutation<OrgAdminEnrollUserCourseStatus200, ResponseErrorConfig<OrgAdminEnrollUserCourseStatus422>, OrgAdminEnrollUserCourseOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<OrgAdminEnrollUserCourseStatus200, ResponseErrorConfig<OrgAdminEnrollUserCourseStatus422>, OrgAdminEnrollUserCourseOptions, TContext>
}
